import React, { useState, useMemo, useEffect } from "react";
import {
  Alert,
  Card,
  CardHeader,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Spinner,
  Input,
} from "reactstrap";
import classnames from "classnames";
import { NumericFormat } from "react-number-format";
import { toast } from "react-toastify";
import BotaoSuporte from "../../Components/Common/BotaoSuporte";
import { ethers } from "ethers";

import { APIClient } from "../../helpers/api_helper";
import ModalVoucher from "./ModalVoucher";

const apiClient = new APIClient();

// AIDEV-NOTE: PIX deposit flow suspended on dashboard; BotaoSuporte active and vouchers preserved
const Trading = ({
  coins,
  contas,
  loading,
  formatCurrency,
  saldos,
  setLoading,
  setFetch,
  tog_center,
  blockedTime,
}) => {
  const [activeTab, setActiveTab] = useState("1");
  const [contaSaida, setContaSaida] = useState(0);
  const [contaDestino, setContaDestino] = useState(0);
  const [transferencia, setTransferencia] = useState(null);
  const [compraDiaria, setCompraDiaria] = useState(null);
  const [contaNome, setContaNome] = useState("");
  const [contaMoeda, setContaMoeda] = useState("");
  const [contaRede, setContaRede] = useState("");
  const [contaCarteira, setContaCarteira] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [modalVoucher, setModalVoucher] = useState(false);
  const clienteData = JSON.parse(localStorage.getItem("authUser"));


  const filteredCoins = useMemo(() => {
    return coins.filter((coin) => coin.cripto_td === 1);
  }, [coins]);

  const handleCoinChange = (e) => {
    const selectedCoin = coins.find((coin) => coin.moeda === e.target.value);
    if (selectedCoin) {
      setContaMoeda(selectedCoin.moeda);
      setContaRede(selectedCoin.rede);
    }
  };

  const transferir = async () => {
    setIsLoading(true);
    const response = await apiClient.post("/cripto-td/contas/transfer", {
      to: contaDestino,
      from: contaSaida,
      valor: parseFloat(transferencia),
    });

    if (response.sucesso) {
      toast.success(response.mensagem);
      setTransferencia(null);
      setLoading(true);
      setFetch(true);
    } else {
      toast.error(response.mensagem);
      console.log(response.dados);
    }
    setIsLoading(false);
  };

  const criarConta = async () => {
    setIsLoading(true);
    if (contaMoeda === "ETH" || contaMoeda === "POL") tog_center();

    // Format carteira as Ethereum address if not BTC or SOL
    let formattedCarteira = contaCarteira;
    if (contaMoeda !== "BTC" && contaMoeda !== "SOL") {
      try {
        formattedCarteira = ethers.utils.getAddress(contaCarteira);
      } catch (error) {
        toast.error("Endereço de carteira inválido");
        setIsLoading(false);
        return;
      }
    }

    const response = await apiClient.post("/cripto-td/contas", {
      user_id: clienteData.data._id,
      nome: contaNome,
      moeda: contaMoeda,
      rede: contaRede,
      carteira: formattedCarteira,
      compra_diaria: parseFloat(compraDiaria),
    });

    if (response.sucesso) {
      toast.success(response.mensagem);
      // Reset all input fields
      setCompraDiaria(null);
      setContaNome("");
      setContaMoeda("");
      setContaRede("");
      setContaCarteira("");
      setLoading(true);
      setFetch(true);
    } else {
      toast.error(response.mensagem);
      console.log(response.dados);
    }
    setIsLoading(false);
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  useEffect(() => {
    if (contas.length > 0) {
      setContaDestino(contas[0].id);
    }
  }, [contas]);

  return (
    <React.Fragment>
      <Col xl={4}>
        <Card>
          <CardHeader className="align-items-center border-0 d-flex">
            <div className="flex-shrink-0">
              <Nav
                className="nav justify-content-end nav-tabs-custom rounded card-header-tabs border-bottom-0"
                role="tablist"
              >
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === "1" })}
                    onClick={() => {
                      toggleTab("1");
                    }}
                  >
                    PIX
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === "2" })}
                    onClick={() => {
                      toggleTab("2");
                    }}
                  >
                    Transferir
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === "3" })}
                    onClick={() => {
                      toggleTab("3");
                    }}
                  >
                    Criar Conta
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
          </CardHeader>
          <div className="card-body p-0">
            {loading || isLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  padding: "20px",
                }}
              >
                <Spinner height={100} width={100} />
              </div>
            ) : (
              <TabContent activeTab={activeTab} className="p-0">
                <TabPane tabId="1">
                  <div className="p-3">
                    <Alert color="warning" className="text-center mb-3">
                      <h6 className="alert-heading fw-bold mb-1">
                        Depósitos via PIX temporariamente desativados
                      </h6>
                      <p className="mb-0">
                        Os depósitos via PIX estão temporariamente desativados. Em caso de dúvidas, entre em contato com o suporte.
                      </p>
                    </Alert>
                    <div className="mt-3 pt-2">
                      <BotaoSuporte
                        className="btn btn-success w-100"
                        texto="Falar com o suporte"
                        mensagem="Olá, gostaria de informações sobre o depósito via PIX."
                      />
                    </div>
                    {parseInt(clienteData?.data?.clientData?.nivel_kyc || 0) !== 0 && (
                      <div className="mt-3 pt-2">
                        <button
                          type="button"
                          className="btn btn-info w-100"
                          disabled={isLoading}
                          onClick={() => setModalVoucher(true)}
                        >
                          Aplicar Voucher
                        </button>
                      </div>
                    )}
                  </div>
                </TabPane>

                <TabPane tabId="2">
                  {!blockedTime ? (
                    <div className="p-3">
                      <Row>
                        <Col xs={6}>
                          <div className="mb-3">
                            <label>Conta Saída :</label>
                            <select
                              className="form-select"
                              value={contaSaida}
                              onChange={(e) =>
                                setContaSaida(parseInt(e.target.value))
                              }
                            >
                              {contaDestino !== 0 && (
                                <option value="0">
                                  Principal ({formatCurrency(saldos[0].counter)}
                                  )
                                </option>
                              )}
                              {contas
                                .filter(
                                  (conta) =>
                                    conta.id.toString() !== contaDestino
                                )
                                .map((conta) => (
                                  <option value={conta.id} key={conta.id}>
                                    {conta.nome} (
                                    {formatCurrency(conta.saldo_brl)})
                                  </option>
                                ))}
                            </select>
                          </div>
                        </Col>
                        <Col xs={6}>
                          <div className="mb-3">
                            <label> Conta Destino :</label>
                            <select
                              className="form-select"
                              value={contaDestino}
                              onChange={(e) =>
                                setContaDestino(parseInt(e.target.value))
                              }
                            >
                              {contaSaida !== 0 && (
                                <option value="0">
                                  Principal ({formatCurrency(saldos[0].counter)}
                                  )
                                </option>
                              )}
                              {contas
                                .filter(
                                  (conta) => conta.id.toString() !== contaSaida
                                )
                                .map((conta) => (
                                  <option value={conta.id} key={conta.id}>
                                    {conta.nome} ( (
                                    {formatCurrency(conta.saldo_brl)})
                                  </option>
                                ))}
                            </select>
                          </div>
                        </Col>
                      </Row>
                      <div>
                        <div className="input-group mb-3">
                          <label className="input-group-text">Valor</label>
                          <NumericFormat
                            className="form-control"
                            placeholder="0,00"
                            value={transferencia}
                            onValueChange={({ value }) =>
                              setTransferencia(parseFloat(value))
                            }
                            thousandSeparator="."
                            decimalSeparator=","
                            decimalScale={2}
                            fixedDecimalScale={true}
                            allowNegative={false}
                          />
                          <label className="input-group-text">R$</label>
                        </div>
                      </div>
                      <div className="mt-3 pt-2">
                        <button
                          type="button"
                          className="btn btn-success w-100"
                          disabled={isLoading || contaSaida === contaDestino}
                          onClick={transferir}
                        >
                          Transferir
                        </button>
                        {contaSaida === contaDestino && (
                          <span className="text-muted">
                            Conta de Saída e Destino devem ser diferentes.
                          </span>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="p-3 text-center">
                      Não são permitidas transações entre 9:45 e 10:15, devido
                      ao horário da compra diária.
                    </div>
                  )}
                </TabPane>

                <TabPane tabId="3">
                  {!blockedTime ? (
                    <div className="p-3">
                      <Row>
                        <Col xs={12}>
                          <div className="mb-3">
                            <label>Moeda :</label>
                            <Input
                              type="select"
                              className="form-select"
                              value={contaMoeda}
                              onChange={handleCoinChange}
                            >
                              <option value="">Escolha uma Moeda</option>
                              {filteredCoins.map(({ id, moeda, rede }) => (
                                <option value={moeda} key={id}>
                                  {moeda} ({rede})
                                </option>
                              ))}
                            </Input>
                          </div>
                        </Col>
                      </Row>
                      <div>
                        <div className="input-group mb-3">
                          <label className="input-group-text">
                            Nome da Conta
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Conta Principal"
                            value={contaNome}
                            onChange={(e) => setContaNome(e.target.value)}
                          />
                        </div>

                        <div className="input-group mb-3">
                          <label className="input-group-text">
                            Compra Diária
                          </label>
                          <NumericFormat
                            className="form-control"
                            placeholder="0,00"
                            value={compraDiaria}
                            onValueChange={({ value }) =>
                              setCompraDiaria(parseFloat(value))
                            }
                            thousandSeparator="."
                            decimalSeparator=","
                            decimalScale={0}
                            suffix=",00"
                            fixedDecimalScale={true}
                            allowNegative={false}
                          />
                          <label className="input-group-text">R$</label>
                        </div>

                        <div className="input-group mb-0">
                          <label className="input-group-text">Carteira</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder={
                              contaMoeda === "BTC"
                                ? "bc1..., 3..., 1..."
                                : contaMoeda === "SOL"
                                  ? "A3z..."
                                  : "0x..."
                            }
                            value={contaCarteira}
                            onChange={(e) => setContaCarteira(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="mt-3 pt-2">
                        <button
                          type="button"
                          className="btn btn-primary w-100"
                          onClick={criarConta}
                        >
                          Criar Conta
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="p-3 text-center">
                      Não são permitidas transações entre 9:45 e 10:15, devido
                      ao horário da compra diária.
                    </div>
                  )}
                </TabPane>
              </TabContent>
            )}
          </div>
        </Card>
      </Col>
      
      <ModalVoucher
        show={modalVoucher}
        setModalVoucher={setModalVoucher}
        setLoading={setLoading}
        setFetch={setFetch}
      />
    </React.Fragment>
  );
};

export default Trading;
